export default "__VITE_ASSET__bWZeUDho__"